import {use} from 'react';

import {ConditionUploadContext} from '../ConditionUploadContext';
import {TConditionUploadContext} from '../types/TConditionUploadContext';

export const useConditionUploadContext = (): TConditionUploadContext => use(ConditionUploadContext);
